import React, { useEffect, useState } from "react";
import { Drawer, Form, Button, Tabs } from "antd";
import BasicSection from "./sections/BasicSection";
import MainFeaturesSection from "./sections/MainFeaturesSection";
import CompareSection from "./sections/CompareSection";
import OverviewSection from "./sections/OverviewSection";
import MediaSection from "./sections/MediaSection";
import api from "../../api";

export default function SavingsFormDrawer({
  open,
  onClose,
  editingRow,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [issuerOptions, setIssuerOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const isEdit = !!editingRow;

  useEffect(() => {
    api.issuers_list({ limit: 100 }).then((res) => {
      if (res?.status === 200) {
        setIssuerOptions(
          res.data.data.map((i) => ({ value: i.id, label: i.name })),
        );
      }
    });
    api.categories_list({ limit: 100, productType: "SAVINGS" }).then((res) => {
      if (res?.status === 200) {
        setCategoryOptions(
          res.data.data.map((c) => ({ value: c.id, label: c.label })),
        );
      }
    });
  }, []);

  useEffect(() => {
    if (open && editingRow) {
      form.setFieldsValue({
        ...editingRow,
        featured: editingRow.featured ?? false,
        issuerId: editingRow.issuer?.id,
        categoryIds: editingRow.categories?.map((c) => c.id) || [],
        keyFacts: editingRow.keyFacts || [],
        pros: editingRow.pros || [],
        cons: editingRow.cons || [],
        currencyTypes: editingRow.currencyTypes || [],
        nonCashIncomeFee: editingRow.nonCashIncomeFee || [],
        cashIncomeRequirement: editingRow.cashIncomeRequirement || [],
        withdrawalOptions: editingRow.withdrawalOptions || [],
      });
    } else if (open) {
      form.resetFields();
    }
  }, [open, editingRow]);

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);

      const res = isEdit
        ? await api.savings_update(editingRow.id, values)
        : await api.savings_create(values);

      if (res?.status === 200 || res?.status === 201) {
        onSuccess(res.data, isEdit);
        onClose();
      }
    } catch {
    } finally {
      setSaving(false);
    }
  };

  const savingsType = Form.useWatch("type", form);

  const tabs = [
    {
      key: "basic",
      label: "Үндсэн",
      children: (
        <BasicSection
          issuerOptions={issuerOptions}
          categoryOptions={categoryOptions}
        />
      ),
    },
    {
      key: "main",
      label: "Үндсэн онцлог",
      children: <MainFeaturesSection />,
    },
    {
      key: "compare",
      label: "Нарийвчилсан",
      children: <CompareSection savingsType={savingsType} />,
    },
    {
      key: "overview",
      label: "Тойм",
      children: <OverviewSection />,
    },
    {
      key: "media",
      label: "Медиа",
      children: <MediaSection />,
    },
  ];

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={isEdit ? "Хадгаламж засах" : "Хадгаламж нэмэх"}
      width={520}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={onClose}>Болих</Button>
          <Button type="primary" loading={saving} onClick={onSave}>
            {isEdit ? "Хадгалах" : "Нэмэх"}
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <Tabs items={tabs} />
      </Form>
    </Drawer>
  );
}
